<template>
  <v-flex d-flex>
    <v-container fluid>
      <div class='elevation-1'>
        <v-toolbar tabs color='grey lighten-5' style='position: relative'>
          <v-toolbar-title class='px-2'>{{$route.meta.title}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </div>

      <v-flex>
        <v-card class='px-2 pb-2 mb-3'>
          <BasicInfo 
          :basic='data.basic'
          :valid='data.valid'
          :exchanges=exchanges
          @client="updateClient"
          @exchange="updateExchange"
          />
      
          <BotInfo :basic='data.basic' />
        </v-card>
      </v-flex>
    </v-container>
  </v-flex>
</template>

<script>
import { isContext } from 'vm';
import BasicInfo from './BasicInfo';
import BotInfo from './BotInfo';
import MongoService from '../../services/mongo.service'
export default {
  data() {
    return {
      exchanges: [],
      loading: false,
      panel: 0,
      subpanel: 0,
      data: {
        basic: { client: '', exchange: '' },
        valid: true
      },
      keys: [],
      result: null
    };
  },
  components: {
    BasicInfo,
    BotInfo
  },
  methods: {
    updateClient(val) {
      this.data.basic.client = val
    },
    updateExchange(val) {
      this.data.basic.exchange = val
    }
  },
  async beforeMount() {
    this.loading = true;
    try {
      const exchangeList = await MongoService.aggregate({
        collection: 'accounts',
        aggregate: [
          { $group: { _id: null, exchange: { $addToSet: '$exchange' } } },
          { $unwind: '$exchange' },
          { $sort: { 'exchange': 1 } },
          { $group: { _id: null, exchange: { $push: '$exchange' } } },
          { $project: { 'exchange': 1, _id: 0 } }
        ]
      })
      this.exchanges = exchangeList[0].exchange;
    } catch (e) {
      console.error(e)
    }
    this.loading = false;
  }
};
</script>
